import { createComponent } from '@mtfe/sweet';
import { common, eventBus, dom } from '@mtfe/sweet-utils';
import { Tabs } from '@mtfe/sweet-components';
import { oadLX } from '@mtfe/sweet-oad';
import tpl from './dom.html';
import style from './style.less';
import store from '../../store/index';

const { storeCommon, storeCoupon, storeRedBag } = store;
const couponMC = 'b_waimai_5podn25d_mc';
const redBagMC = 'b_waimai_4kttfs5q_mc';
const { TabsPane } = Tabs;

const { createUniqueId, throttle, isFunction } = common;
const tabsID = createUniqueId();
const wrapperID = createUniqueId();
const couponTitle = createUniqueId();
const redBagTitle = createUniqueId();

const couponActiveStyle = style['wrapper-coupon-active'];
const redBagActiveStyle = style['wrapper-red-bag-active'];
const ceilingCouponActiveStyle = style['wrapper-ceiling-coupon-active'];
const ceilingRedBagActiveStyle = style['wrapper-ceiling-red-bag-active'];
const tabBgStyleArr = [
    couponActiveStyle,
    redBagActiveStyle,
    ceilingCouponActiveStyle,
    ceilingRedBagActiveStyle,
];
const titleCouponActive = style['title-coupon-active'];
const titleRedBagActive = style['title-red-bag-active'];

let isCeiling = false;
let currentActiveKey = null;

// 红包Active样式控制
const redBagActive = () => {
    const wrapperDom = dom.$id(wrapperID);
    const redBagDom = dom.$id(storeRedBag.tabsContainerID);
    const couponDom = dom.$id(storeCoupon.tabsContainerID);
    const couponTitleDom = dom.$id(couponTitle);
    const redBagTitleDom = dom.$id(redBagTitle);

    wrapperDom.classList.remove(...tabBgStyleArr);
    if (isCeiling) {
        wrapperDom.classList.add(ceilingRedBagActiveStyle);
    } else {
        wrapperDom.classList.add(redBagActiveStyle);
    }
    redBagDom.style.display = '';
    couponDom.style.display = 'none';
    couponTitleDom.classList.remove(titleCouponActive);
    redBagTitleDom.classList.remove(titleCouponActive);
    couponTitleDom.classList.add(titleRedBagActive);
    redBagTitleDom.classList.add(titleRedBagActive);
};

// 券Active样式控制
const couponActive = () => {
    const wrapperDom = dom.$id(wrapperID);
    const redBagDom = dom.$id(storeRedBag.tabsContainerID);
    const couponDom = dom.$id(storeCoupon.tabsContainerID);
    const couponTitleDom = dom.$id(couponTitle);
    const redBagTitleDom = dom.$id(redBagTitle);

    wrapperDom.classList.remove(...tabBgStyleArr);
    if (isCeiling) {
        wrapperDom.classList.add(ceilingCouponActiveStyle);
    } else {
        wrapperDom.classList.add(couponActiveStyle);
    }
    redBagDom.style.display = 'none';
    couponDom.style.display = '';
    couponTitleDom.classList.remove(titleRedBagActive);
    redBagTitleDom.classList.remove(titleRedBagActive);
    couponTitleDom.classList.add(titleCouponActive);
    redBagTitleDom.classList.add(titleCouponActive);
};

const WelfareTabsReady = () => {
    eventBus.$on('WelfareTabsReady', () => {
        const { isShowRedBag, isShowCoupon } = storeCommon;
        const wrapperDom = dom.$id(wrapperID);
        const onSticky = () => {
            const { top } = wrapperDom.getBoundingClientRect();

            // 适配手机端的情况，手机端top值不稳定
            if (top < 0 || Math.abs(top) <= 1) {
                isCeiling = true;
            } else {
                isCeiling = false;
            }
            if (currentActiveKey === storeCoupon.recallBizId) {
                couponActive();
            } else if (currentActiveKey === storeRedBag.recallBizId) {
                redBagActive();
            }
        };
        if (isShowRedBag && isShowCoupon) {
            document.addEventListener('scroll', throttle(onSticky, 200));
        }
    });
};

const WelfareTabs = (props = {}) => {
    const {
        onClickTabsCb,
        defaultActiveTab = storeRedBag.recallBizId,
        couponComponent,
        redBagComponent,
    } = props;

    currentActiveKey = defaultActiveTab;

    if (defaultActiveTab === storeCoupon.recallBizId) {
        style.defaultActive = couponActiveStyle;
        style.defaultTitle = titleCouponActive;
    } else if (defaultActiveTab === storeRedBag.recallBizId) {
        style.defaultActive = redBagActiveStyle;
        style.defaultTitle = titleRedBagActive;
    }

    const events = {
        onClickTabs: async (key) => {
            // 1.打点上报
            // 2.切换tab
            if (key === storeCoupon.recallBizId) {
                oadLX.mc(couponMC);
                couponActive();
            } else if (key === storeRedBag.recallBizId) {
                oadLX.mc(redBagMC);
                redBagActive();
            }
            currentActiveKey = key;
            // 3.执行回调
            if (isFunction(onClickTabsCb)) {
                onClickTabsCb(key);
            }
        },
    };

    const data = {
        tabsID,
        wrapperID,
        couponTitle,
        redBagTitle,
        couponTabsKey: storeCoupon.recallBizId,
        redBagTabsKey: storeRedBag.recallBizId,
        couponComponent: TabsPane({
            tabContainerID: storeCoupon.tabsContainerID,
            innerComponent: couponComponent,
            defaultDisplay: currentActiveKey === storeCoupon.recallBizId,
        }),
        redBagComponent: TabsPane({
            tabContainerID: storeRedBag.tabsContainerID,
            innerComponent: redBagComponent,
            defaultDisplay: currentActiveKey === storeRedBag.recallBizId,
        }),
    };

    WelfareTabsReady();
    return createComponent(tpl, { style, data }, events);
};

export default WelfareTabs;
